import React, { useContext } from 'react';
import styled from 'styled-components';

// Material
import Button from '@material-ui/core/Button';
import vectorGraphic from './no_result.svg';

// Context & Actions
import { TrainsContext, actionTypes } from '../../../TrainsContext';

const Wrapper = styled.div`
  padding: 60px 0;
  text-align: center;

  img {
    max-width: 100%;
    height: 120px;
    margin-bottom: 16px;
  }

  h5 {
    font-size: 24px;
    margin-bottom: 16px;
  }
`;

const EmptyState = () => {
  const { dispatch } = useContext(TrainsContext);

  const handleResetSearch = () => {
    dispatch({ type: actionTypes.RESET_SEARCH });
  };

  return (
    <Wrapper>
      <img src={vectorGraphic} alt="No search results" />
      <h5>No trains found</h5>
      <p>Try adjusting your departure time or target stations</p>
      <Button variant="contained" color="secondary" onClick={handleResetSearch}>
        Search again
      </Button>
    </Wrapper>
  );
};

export default EmptyState;
